<template>
  <div
    class="bblayout"
    :class="{ 'is-iosapp': bridge.isIniOSApp, 'is-androidapp': bridge.isInAndroidApp }"
  >
    <Header :back-black="true" :is-relative="true" />
    <div class="bblayout__content">
      <!-- <div class="success">
        <img class="success__icon"
          src="https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/subscribe-sdk-car-rental-success.png"
          alt="">
        <div class="success__title">提交成功</div>
        <div class="success__hint">我们将在1个工作日内与您联系，<br>您可以留意微信“服务通知”—“企业微信邀请通知”</div>
        <div class="success__tips" v-if="showToAuth" @click="toAuth">完成用车人认证更容易订到哦！</div>
      </div> -->
      <div class="qrcode">
        <div class="qrcode__text">
          <div class="qrcode__text-line">
            亲爱的Z客，我们将在1个工作日内与您联系，请您留意微信“服务通知”—“企业微信邀请通知”
          </div>
          <div class="qrcode__text-line">
            您也可以直接添加@极氪订阅体验官的企业微信，即刻进行咨询！若有更多问题请联系400-0036-036！
          </div>
        </div>
        <div class="">
          <img
            class="qrcode__img"
            src="https://hhstaticource.oss-cn-hangzhou.aliyuncs.com/web-static-source/subscribe/images/faq2page-zeekr-qrcode.png"
            alt=""
          />
        </div>
        <div class="qrcode__hint">截图保存图片，扫码添加@订阅体验官企业微信</div>
      </div>
    </div>
    <div class="bblayout__bottom">
      <div class="simplebtn simplebtn--highlight" @click="back">完成</div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import Header from "./component/header.vue";
const bridge = window.bridge
const showToAuth = ref(false);
const back = () => {
  bridge.navigateBack({});
};
const toAuth = () => {
  const path = "app://route/openNative?path=/subscription/Auth";
  if (bridge.isInAndroidApp) {
    bridge.toRouter({ route: path });
  } else {
    bridge.navigate({ route: path });
  }
};
const timeId = ref(null);
const checkUserAuth = () => {
  bridge.getSubscriptionInfo().then((subscriptionInfo) => {
    if (subscriptionInfo.success) {
      showToAuth.value = !subscriptionInfo.userAuth;
      if (showToAuth.value) timeId.value = setTimeout(checkUserAuth, 1000);
    }
  });
};
onMounted(() => {
  checkUserAuth();
  if (bridge.isInAndroidApp) {
    bridge.setStatusBar({ isTransparency: true });
    bridge.getStatusHeight().then((subscriptionInfo) => {
      if (subscriptionInfo.success) {
        setStatusHeight(subscriptionInfo.statusHeight / 2);
      }
    });
  }
});
const setStatusHeight = (statusHeight) => {
  const header = document.querySelector(".header");
  if (header) header.setAttribute("style", `padding-top:${statusHeight}px;`);
};
onUnmounted(() => {
  clearTimeout(timeId.value);
});
</script>
<style lang="scss" scoped>
@import url("@/style/bottombarlayout.scss");
@import url("@/style/simplebtn.scss");
.is-androidapp {
  ::v-deep .header {
    padding-top: 50px;
  }
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 80px 40px;
}

.success__icon {
  width: 120px;
  height: 120px;
}

.success__title {
  margin-top: 16px;
  font-size: 34px;
  color: #232323;
  font-weight: 500;
}

.success__hint {
  margin-top: 16px;
  font-size: 28px;
  color: #8e9496;
  font-weight: 400;
}

.success__tips {
  display: flex;
  align-items: center;
  padding: 24px 40px;
  font-size: 30px;
  color: #ff5800;
  text-align: left;
  background: #fff0e7;
  font-weight: 400;
  width: 100%;
  margin-top: 64px;
  box-sizing: border-box;
  justify-content: space-between;

  &::after {
    content: "";
    width: 12px;
    height: 12px;
    border-right: 2px solid #ff5800;
    border-top: 2px solid #ff5800;
    transform: rotate(45deg);
    margin-left: 14px;
  }
}
.qrcode {
  color: #232323;
  font-size: 34px;
  text-align: center;
}
.qrcode__img {
  width: 33%;
}
.qrcode__hint {
  margin-top: 45px;
  font-size: 24px;
  color: #7c7f80;
}
.qrcode__text {
  padding: 100px 60px 140px;
  position: relative;
  text-align: left;
  font-weight: 400;
  .qrcode__text-line:first-child::before {
    content: "";
    height: 32px;
    width: 10px;
    border-radius: 5px;
    background-color: #ff5800;
    margin-right: 10px;
    display: inline-block;
    transform: translate(0, 5px);
  }
  .qrcode__text-line + .qrcode__text-line {
    margin-top: 40px;
  }
}
</style>
